import {exists} from 'shared/utils/custom-utils';

const specialSymbolsKeyboardLocalStorageKey = 'specialSymbolsKeyboard';

interface SpecialSymbolsKeyboardSettingsHolder {
    lastUsedSymbols: string[];
}

const maxLastUsedSymbols = 16;
const lastUsedSymbolsDefaults = [
    'Ľ',
    'ł',
    'Α',
    'Β',
    'Γ',
    'Δ',
    'ä',
    'ö',
    'ü',
    '"',
    '\''
];

class SpecialSymbolsKeyboardStorage {

    public saveLastUsedSymbol(symbol: string): void {
        const settingsHolder = this.getLocalStorageSettingsHolder();

        const symbolIndex = settingsHolder.lastUsedSymbols.indexOf(symbol);

        if (symbolIndex !== -1) {
            settingsHolder.lastUsedSymbols.splice(symbolIndex, 1);
        }

        settingsHolder.lastUsedSymbols.unshift(symbol);

        if (settingsHolder.lastUsedSymbols.length > maxLastUsedSymbols) {
            settingsHolder.lastUsedSymbols.pop();
        }

        this.saveLocalStorageSettingsHolder(settingsHolder);
    }

    public getLastUsedSymbols(): string[] {
        const settingsHolder = this.getLocalStorageSettingsHolder();
        return settingsHolder.lastUsedSymbols;
    }

    private getLocalStorageSettingsHolder(): SpecialSymbolsKeyboardSettingsHolder {
        const jsonString = localStorage.getItem(specialSymbolsKeyboardLocalStorageKey);

        if (!exists(jsonString) || !jsonString) {
            const settingsHolder = {lastUsedSymbols: lastUsedSymbolsDefaults} as SpecialSymbolsKeyboardSettingsHolder;
            this.saveLocalStorageSettingsHolder(settingsHolder);

            return settingsHolder;
        }

        try {
            return JSON.parse(jsonString) as SpecialSymbolsKeyboardSettingsHolder;
        } catch {
            const settingsHolder = {lastUsedSymbols: lastUsedSymbolsDefaults} as SpecialSymbolsKeyboardSettingsHolder;
            this.saveLocalStorageSettingsHolder(settingsHolder);

            return settingsHolder;
        }
    }

    private saveLocalStorageSettingsHolder(settingsHolder: SpecialSymbolsKeyboardSettingsHolder) {
        localStorage.setItem(specialSymbolsKeyboardLocalStorageKey, JSON.stringify(settingsHolder));
    }
}

export const specialSymbolsKeyboardStorage = new SpecialSymbolsKeyboardStorage();